import React from "react";
import Apply from "./Apply";

const HRAdmin = () => {
  // Access to this page is already gated by the sidebar's "HR Access"
  // password popup (AdminLayout), same as Projects/Gallery/CSR/Policies,
  // so there's no separate login step to wait for here anymore.
  return (
    <div className="min-h-screen p-6 bg-gray-50">
      <h1 className="text-3xl font-bold mb-6 text-blue-900">HR Applications</h1>

      <div className="mb-8 p-5 bg-white rounded-xl shadow border border-blue-100 flex items-center justify-between">
        <div>
          <h2 className="text-lg font-semibold text-blue-800 mb-1">CSR Module</h2>
          <p className="text-sm text-gray-500">Manage CSR reports, policies & expenditure</p>
        </div>
      </div>

      <Apply />
    </div>
  );
};

export default HRAdmin;